
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('top-page')) {
      return;
    }

    var scrollIndicator = document.querySelector('.fv__scroll');
    if (!scrollIndicator) return;

    
    var isHidden = false;
    function handleScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (y > 100) {
        if (!isHidden) {
          scrollIndicator.classList.add('is-scrolled');
          isHidden = true;
        }
      } else {
        if (isHidden) {
          scrollIndicator.classList.remove('is-scrolled');
          isHidden = false;
        }
      }
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    
    scrollIndicator.addEventListener('click', function () {
      var nextSection = document.querySelector('.news');
      if (!nextSection) return;
      nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    scrollIndicator.style.cursor = 'pointer';
  });
})();
